import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import styled from 'styled-components';

const CurrencyContainer = styled.span`
  color: ${props => {
    if (props.type === 'emphasis') return '#f50057';
    if (props.type === 'disabled') return '#949494';
    return 'inherit';
  }};
  font-size: ${props => {
    if (props.size === 'inherit') return 'inherit';
    if (props.size === 'small') return '14px';
    if (props.size === 'large') return '18px';
    return '16px';
  }};
  font-weight: ${props => (props.fontWeight === 'normal' ? 'normal' : 'bold')};
  text-decoration: ${props => (props.type === 'disabled' ? 'line-through' : 'inherit')};

  .currency-unit {
    font-size: calc(100% - 3px);
  }
`;

@inject('menuStore')
@observer
class CurrencyDisplay extends Component {
  render() {
    const { menuStore, amount, minus, plus, currency } = this.props;

    if (menuStore.storeData.culture === 'ko-KR') {
      return (
        <CurrencyContainer {...this.props}>
          {minus && amount > 0 && <span>-</span>}
          {plus && amount > 0 && <span>+</span>}
          <span className="amount">{menuStore.numberFormatByLocale(amount)}</span>
          {currency !== false && <span className="currency-unit">{menuStore.currencyUnit}</span>}
        </CurrencyContainer>
      );
    } else {
      return (
        <CurrencyContainer {...this.props}>
          <span className="price">
            {minus && amount > 0 && <span>-</span>}
            {plus && amount > 0 && <span>+</span>}
            <span className="currency-symbol">{menuStore.currencySymbol}</span>{' '}
            <span className="amount">{menuStore.numberFormatByLocale(amount)}</span>
          </span>
        </CurrencyContainer>
      );
    }
  }
}

export default CurrencyDisplay;
